import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-special-travels',
  templateUrl: './special-travels.component.html',
  styleUrls: ['./special-travels.component.scss']
})
export class SpecialTravelsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/rafaelneves/code/ads/ardaexperience/src/app/pages/special-travels/special-travels.component.ts